export default "__VITE_ASSET__DEK88tjE__"